import { useI18n } from "vue-i18n";
import { ChildType } from "@/Components/LinkedTo";

export default function parseSpaces(linkedTo) {
    if (linkedTo.length === 1) {
        return linkedTo[0].name;
    }

    let items = [];

    const spaces = linkedTo.filter(
        (space) =>
            space.type.value !== ChildType.ASSET &&
            space.type.value !== ChildType.ASSET_GROUP
    );
    const assets = linkedTo.filter(
        (space) => space.type.value === ChildType.ASSET
    );
    const assets_groups = linkedTo.filter(
        (space) => space.type.value === ChildType.ASSET_GROUP
    );

    if (spaces.length > 0) {
        items.push(
            useI18n().t("components.filters.badges.spaces", spaces.length)
        );
    }
    if (assets.length > 0) {
        items.push(
            useI18n().t("components.filters.badges.assets", assets.length)
        );
    }
    if (assets_groups.length > 0) {
        items.push(
            useI18n().t(
                "components.filters.badges.asset_groups",
                assets_groups.length
            )
        );
    }

    return items.join(", ");
}
